export const pin = {
  name: "pin" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M6.734 3.027A.9.9 0 0 1 7.5 2.6h9a.9.9 0 0 1 .805 1.302L15.9 6.712v4.555l2.387 4.296A.9.9 0 0 1 17.5 16.9h-4.6V22a.9.9 0 0 1-1.8 0v-5.1H6.5a.9.9 0 0 1-.787-1.337L8.1 11.267V6.712l-1.405-2.81a.9.9 0 0 1 .04-.875ZM9.9 7.4v4.1a.9.9 0 0 1-.113.437L8.03 15.1h7.94l-1.757-3.163a.901.901 0 0 1-.113-.437v-5a.9.9 0 0 1 .095-.403l.849-1.697H8.956l.6 1.2H12.5a.9.9 0 0 1 0 1.8H9.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["pin"],
  category: "other" as const,
};
